// extracted by mini-css-extract-plugin
export var askAiIcon = "_r3-9";
export var container = "_r3-0";
export var groupSeparator = "_r3-a";
export var highlight = "_r3-4";
export var resultIcon = "_r3-5";
export var resultItem = "_r3-7";
export var resultSubtitle = "_r3-3";
export var resultTitle = "_r3-2";
export var resultsList = "_r3-1";
export var searchGroup = "_r3-6";
export var selected = "_r3-8";